import React from 'react';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const CalloutIcon = React.memo(function CalloutIcon(props: TCalloutIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Callout Block" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5 15V7H18.5V15H3.5ZM2 6.5C2 5.94771 2.44772 5.5 3 5.5H19C19.5523 5.5 20 5.94772 20 6.5V15.5C20 16.0523 19.5523 16.5 19 16.5H3C2.44772 16.5 2 16.0523 2 15.5V6.5ZM6.5 9C6.5 8.86193 6.61193 8.75 6.75 8.75H15.25C15.3881 8.75 15.5 8.86193 15.5 9V10C15.5 10.1381 15.3881 10.25 15.25 10.25H6.75C6.61193 10.25 6.5 10.1381 6.5 10V9ZM6.5 12C6.5 11.8619 6.61193 11.75 6.75 11.75H11.25C11.3881 11.75 11.5 11.8619 11.5 12V13C11.5 13.1381 11.3881 13.25 11.25 13.25H6.75C6.61193 13.25 6.5 13.1381 6.5 13V12Z"
            />
            <rect x="2" y="18.5" width="18" height="1.5" rx="0.5" />
            <rect x="2" y="2" width="18" height="1.5" rx="0.5" />
        </IconBase>
    );
});

export default CalloutIcon;

// #region Types

export type TCalloutIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <CalloutIcon /> : { ...IconBaseExample, render: CalloutIcon };

// #endregion
